import React from 'react';
import Deploy from './Deploy';
import {DataTableContextProvider} from './Utils/DataTableContext';
import {colors} from './defaultSettings';

const css = (`
  .xd_dt_cell {background: ${colors.bg.row0}}
  .xd_dt_cell.odd {background: ${colors.bg.row1}}
  .xd_dt_cell:hover {background: ${colors.bg.rowHov}}
`).trim();
const style = document.createElement('style');
if (style.styleSheet) style.styleSheet.cssText = css;
else style.appendChild(document.createTextNode(css));

document.getElementsByTagName('head')[0].appendChild(style);

const DataTableConstruct = props => {
  const defaultSettings = {
    menus: {},
  }
  const settings = props.settings
  ? {
    ...defaultSettings,
    ...props.settings,
  }
  : defaultSettings;
  const headerSettings = settings.headers ? settings.headers : props.headerSettings;
  return(
    <DataTableContextProvider {...props} dataTableID={props.tableID || 'dt_instance_0'}>
        <Deploy {...props} settings={settings} headerSettings={headerSettings} />
    </DataTableContextProvider>
  )
}

export default DataTableConstruct;
